var React = require('react');

function WhyDigitalBackgroundBot3 (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M800 0H0V10C0 42.218 55.6922 41.7582 244.502 40.1994C293.534 39.7946 351.543 39.3157 419.886 39.3157C751.367 39.3157 799.999 41.4145 800.008 81.9887L800 10V0Z","fill":"#3290FF"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("rect",{"width":"800","height":"82","fill":"white"})))]);
}

WhyDigitalBackgroundBot3.defaultProps = {"width":"800","height":"82","viewBox":"0 0 800 82","preserveAspectRatio":"none","fill":"none"};

module.exports = WhyDigitalBackgroundBot3;

WhyDigitalBackgroundBot3.default = WhyDigitalBackgroundBot3;
